import { AppRoute } from '@ts-routes/enums'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  const signature = (to.query?.signature as string | undefined) ?? undefined
  if (signature) return

  const redirects: Record<string, string> = {
    '/home': AppRoute.Home,
    '/homepage': AppRoute.Home,
  }

  const norm = to.path.toLowerCase()
  const target = redirects[norm]
  if (target && norm !== target) {
    return navigateTo(target, { redirectCode: 301 })
  }
})
